import { render, staticRenderFns } from "./SetProductCategory.vue?vue&type=template&id=19bd3394&scoped=true"
import script from "./SetProductCategory.vue?vue&type=script&lang=js"
export * from "./SetProductCategory.vue?vue&type=script&lang=js"
import style0 from "./SetProductCategory.vue?vue&type=style&index=0&id=19bd3394&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bd3394",
  null
  
)

export default component.exports